import React from 'react';

var OverlayItem = function (_a) {
    var isOpen = _a.isOpen, children = _a.children, settingsRef = _a.settingsRef;
    return (React.createElement("div", { ref: settingsRef, className: "pgc-overlay-section ".concat(isOpen ? 'open' : '') }, children));
};

export { OverlayItem };
